import script from "./LimiteUsuariosUnidad.vue?vue&type=script&setup=true&lang=js"
export * from "./LimiteUsuariosUnidad.vue?vue&type=script&setup=true&lang=js"

import "./LimiteUsuariosUnidad.vue?vue&type=style&index=0&id=5b92e7ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b92e7ea"]])

export default __exports__